import { render, staticRenderFns } from "./BookingAppointment.vue?vue&type=template&id=337640a0"
import script from "./BookingAppointment.vue?vue&type=script&lang=js"
export * from "./BookingAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports